import { type ClientContext, ContextClient } from '~/services/contextClient';
import BlastForecastClientFactory from './blastForecastClient.factory';
import {
    type BlastForecastClientInterface,
    type GetBlastForecastRequest,
    type AdjustCampaignRequest,
} from './blastForecastClient.types';

class BlastForecastClient extends ContextClient<BlastForecastClientInterface> {
    constructor() {
        super(BlastForecastClientFactory);
    }

    getBlastForecastSummary(context: ClientContext, params: GetBlastForecastRequest) {
        const client = this.getClient(context);
        return client.getBlastForecastSummary(params);
    }

    getBlastForecastCampaigns(context: ClientContext, params: GetBlastForecastRequest) {
        const client = this.getClient(context);
        return client.getBlastForecastCampaigns(params);
    }

    adjustCampaign(context: ClientContext, campaignId: number, payload: AdjustCampaignRequest) {
        const client = this.getClient(context);
        if (!client.adjustCampaign) {
            throw new Error(`adjustCampaign not supported by ${client.constructor.name}`);
        }
        return client.adjustCampaign(campaignId, payload);
    }
}

export default new BlastForecastClient();
